var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheModal'),_c('TheNotification'),_c('TheTopbar'),_c('TheSidebar'),_c('TheContentBar'),_c('TheContents'),_c('TheNotifications'),_c('vue-confirm-dialog',{staticClass:"vue-confirm-dialog"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }